import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from 'components';
import OrganizationsListTable from './components/OrganizationsListTable';
import OrganizationEditModalForm from './components/OrganizationEditModalForm';
import _ from 'lodash';
import { useEvents } from 'hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const OrganizationsPage = ({ organizations, isFetchingOrganizations, setSelectedOrganization, saveOrganization }) => {
  const [pagePropsAction, setPagePropsAction] = useState('organization_add');
  const classes = useStyles();
  const pageProps = {};
  const { t } = useTranslation();
  const [selectedOrgId] = useState();
  const [selectedOrg, setSelectedOrg] = useState();
  const [showModifyOrganizationModal, setShowModifyOrganization] = useState(false);
  const { setFilter } = useEvents();

  pageProps.actionFab = true;
  pageProps.actionHref = () => {
    setAndShowOrganizationToModify();
  };
  pageProps.action = pagePropsAction;
  pageProps.icon = <AddIcon />;

  const setAndShowOrganizationToModify = () => {
    let tempSelectedOrg = {};
    tempSelectedOrg = _.find(organizations, (organization) => {
      return organization.id === selectedOrgId;
    });
    setSelectedOrg(tempSelectedOrg);

    if (!showModifyOrganizationModal) {
      setShowModifyOrganization(true);
    }
  };

  const tableSelectOrganization = (organization) => {
    setSelectedOrg(organization.id);
    setSelectedOrganization(organization.id);
    setFilter({ organization_id: organization.id });
    setShowModifyOrganization(true);
  };

  const organizationModifySubmitHandler = (modifiedOrganization) => {
    let tempActiveOrganization = selectedOrg;
    _.forOwn(modifiedOrganization, function (value, key) {
      tempActiveOrganization = {
        ...tempActiveOrganization,
        [key]: value,
      };
    });

    if (tempActiveOrganization) {
      saveOrganization(tempActiveOrganization);
    }
  };

  return (
    <Page title={t('org_admin')} className={classes.root}>
      <Modal
        open={showModifyOrganizationModal}
        onClose={() => {}}
        aria-labelledby="modal-organization-edit"
        aria-describedby="modal-organization-edit-form"
      >
        <div>
          <OrganizationEditModalForm
            show={showModifyOrganizationModal}
            organization={selectedOrg}
            submitEdit={organizationModifySubmitHandler}
            hide={() => setShowModifyOrganization(false)}
          />
        </div>
      </Modal>

      <PageHeader title="orgs" {...pageProps} className={classes.header} />
      <div style={{ marginBottom: 16 }} />
      <OrganizationsListTable
        organizations={organizations}
        setPagePropsAction={setPagePropsAction}
        SelectedOrgId={selectedOrgId}
        isFetchingOrganizations={isFetchingOrganizations}
        handleOrganizationSelect={(organization) => tableSelectOrganization(organization)}
      />
    </Page>
  );
};

OrganizationsPage.propTypes = {
  organizations: PropTypes.array,
  isFetchingOrganizations: PropTypes.bool.isRequired,
  setSelectedOrganization: PropTypes.func.isRequired,
  saveOrganization: PropTypes.func.isRequired,
  fetchOrganizations: PropTypes.func.isRequired,
};

OrganizationsPage.defaultProps = {
  organizations: [],
  selectedOrganization: undefined,
};

export default OrganizationsPage;
